import { render } from "./TTMInjectionWellForm.vue?vue&type=template&id=1e6acca1"
import script from "./TTMInjectionWellForm.vue?vue&type=script&setup=true&lang=js"
export * from "./TTMInjectionWellForm.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/scada/forms/TTMInjectionWellForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1e6acca1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1e6acca1', __exports__)) {
    console.log('reload')
    api.reload('1e6acca1', __exports__)
  }
  
  module.hot.accept("./TTMInjectionWellForm.vue?vue&type=template&id=1e6acca1", () => {
    console.log('re-render')
    api.rerender('1e6acca1', render)
  })

}


export default __exports__